import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import { SessionProvider } from "./lib/session";
import "./index.css";

const el = document.getElementById("root");
if (!el) throw new Error("#root 를 찾을 수 없다");

createRoot(el).render(
  <StrictMode>
    <SessionProvider>
      <RouterProvider router={router} />
    </SessionProvider>
  </StrictMode>,
);
